{
  "title": "Status Reference",
  "description": "What each submission and score status means, and what you can do while a submission or score is in it.",
  "headings": ["Submission Statuses", "Score Statuses"],
  "intro": "These are the statuses actually used by the platform, for quickly looking up what's editable and what counts as formally submitted.",
  "submissionSectionHeading": "Submission Statuses",
  "submissionStatusDiagram": "stateDiagram-v2\n    [*] --> Draft\n    Draft --> Ready\n    Ready --> Draft\n    Ready --> Submitted: final submit\n    Submitted --> Locked: organizer locks\n    Submitted --> Ready: return/unlock\n    Locked --> Ready: return/unlock\n    Submitted --> Withdrawn: withdraw\n    Locked --> Withdrawn: withdraw\n    Submitted --> Disqualified: disqualify\n    Locked --> Disqualified: disqualify",
  "submissionStatuses": [
    { "name": "Draft", "editable": "Editable", "formalSubmit": "Not formally submitted" },
    { "name": "Ready", "editable": "Editable", "formalSubmit": "Not formally submitted" },
    { "name": "Submitted", "editable": "Not editable", "formalSubmit": "Formally submitted" },
    { "name": "Locked", "editable": "Not editable", "formalSubmit": "Formally submitted" }
  ],
  "judgeSectionHeading": "Score Statuses",
  "judgeStatuses": [
    {
      "name": "Assigned",
      "description": "The judge has been assigned this submission but hasn't started scoring."
    },
    {
      "name": "Draft Score",
      "description": "The judge has saved a draft score but hasn't submitted it yet."
    },
    {
      "name": "Submitted",
      "description": "The judge has formally submitted a score, which locks it immediately."
    },
    {
      "name": "Locked",
      "description": "The score is locked; the organizer can click \"Reopen\" to return it to Draft Score if needed."
    }
  ]
}
